<!-- **** --------------------------------------------------------------------------
	SHARED SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts">
    import vm from '@journeys/Journeys.viewmodel';
    import { NodeType, StepTypes, ConditionDelayMultiplier } from '@journeys/Enums';
    import HSLColors from '@shared/components/ColorPickers/HSLColorValues';
    import { NodeFrame, NodeIcon } from '@journeys/components/NodePartials/NodeAssets';
</script>

<!-- **** --------------------------------------------------------------------------
	SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts" setup>
    // components

    import { bitshift } from '@shared/utils';
    import { computed, ref } from 'vue';
    // import { ENode } from '@cwd/Journeys/binaryWorker'
    import ScrollableContainer from '@shared/components/ScrollableContainer.vue';

    const { canvas, editor, nav, settings } = vm;

    const props = defineProps<{}>();
</script>

<!-- **** --------------------------------------------------------------------------
	TEMPLATE
-------------------------------------------------------------------------- **** -->
<template>
    <ScrollableContainer>
        <h3 class="title mt-md mb-md">selected nodes</h3>

        <div class="section-group mt-sm" v-for="item in editor.tools.sel_nodes" :key="item.id">
            <h4 class="small mv-sm">
                id:
                <span class="fw800">{{ item.id }}</span>
            </h4>
            <div class="section-group">
                <h4 class="subheading mt-md opaque">Title:</h4>
                <h3 class="mb-sm">{{ item.data.title || 'Untitled' }}</h3>
                <h4 class="subheading opaque">Description:</h4>
                <h4>{{ item.data.description || 'No description' }}</h4>
                <h4 class="subheading mt-xs opaque">Datatype:</h4>
                <h4>
                    {{ NodeType[item.data.type] || 'No description' }} - enum:
                    <span>{{ item.data.type }}</span>
                </h4>
            </div>
            <h3>Graphical properties</h3>
            <div class="section-group">
                <h4 class="subheading mt-xs opaque">Frame:</h4>
                <h4>
                    {{ NodeFrame[item.f] || 'No description' }} - enum:
                    <span>{{ item.f }}</span>
                </h4>
                <h4 class="subheading mt-xs opaque">Icon:</h4>
                <h4>
                    {{ NodeIcon[item.i] || 'No description' }} - enum:
                    <span>{{ item.i }}</span>
                </h4>

                <h3 class="mt-l">Colors</h3>

                <h4 class="subheading mt-xs opaque">Frame:</h4>
                <h4>
                    Enum:
                    <span>{{ item.fc }}</span>
                </h4>
                <h4 class="subheading mt-xs opaque">Icon:</h4>
                <h4>
                    Enum:
                    <span>{{ item.ic }}</span>
                </h4>
            </div>

            <h3 class="title mt-md">Position properties</h3>
            <div class="section-group">
                <h4 class="small mv-xs">
                    height:
                    <span class="fw600">{{ item.h }}</span>
                </h4>
                <h4 class="small">
                    width:
                    <span class="fw600">{{ item.w }}</span>
                </h4>
                <div class="fl" style="justify-content: space-between; width: 60%">
                    <h4 class="small mv-xs">
                        x:
                        <span class="fw600">{{ item.x }}</span>
                    </h4>
                    <h4 class="small mv-xs">
                        y:
                        <span class="fw600">{{ item.y }}</span>
                    </h4>
                    <h4 class="small mv-xs">
                        z:
                        <span class="fw600">{{ item.z }}</span>
                    </h4>
                </div>
            </div>

            <h3 class="title mt-md">Line connections ... soon</h3>
            -------------------------------------
        </div>

        <!-- // node area show: occupied, head element(invisible), pseudo element -->
    </ScrollableContainer>
</template>

<!-- **** --------------------------------------------------------------------------
	STYLES
-------------------------------------------------------------------------- **** -->
<style>
    .input-group .input-wrapper .fluid-input:not(.c) {
        margin-left: 0;
    }

    .opaque {
        opacity: 0.55;
    }
</style>
